// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';
import LocationSchema from './location-schema';

const schema = {
  $id: '/tdg-company-list-schema',
  type: 'object',
  required: ['id', 'creatorId', 'eventId'],
  nullable: true,
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    externalId: {
      type: 'string',
      format: 'uuid',
    },
    companyName: {
      type: 'string',
      nullable: true,
    },
    organisationId: {
      type: 'string',
      nullable: true,
    },
    organisationName: {
      type: 'string',
      nullable: true,
    },
    logoDocumentId: {
      type: 'integer',
      nullable: true,
    },
    description: {
      type: 'string',
      nullable: true,
    },
    website: {
      type: 'string',
      nullable: true,
    },
    employeesCount: {
      type: 'integer',
      nullable: true,
    },
    apprenticesCount: {
      type: 'integer',
      nullable: true,
    },
    apprenticeshipsCount: {
      type: 'integer',
      nullable: true,
    },
    companyContactSalutation: {
      type: 'integer',
      nullable: true,
    },
    companyContactFirstName: {
      type: 'string',
      nullable: true,
    },
    companyContactLastName: {
      type: 'string',
      nullable: true,
    },
    companyContactPhoneNumber: {
      type: 'string',
      nullable: true,
    },
    companyContactEmail: {
      type: 'string',
      nullable: true,
    },
    companyStreet: {
      type: 'string',
      nullable: true,
    },
    companyHouseNumber: {
      type: 'string',
      nullable: true,
    },
    companyZIP: {
      type: 'string',
      nullable: true,
    },
    companyCity: {
      type: 'string',
      nullable: true,
    },
    companyLocation: {
      ...LocationSchema,
    },
    acceptConditions: {
      type: 'boolean',
    },
    eventId: {
      type: 'integer',
    },
    eventName: {
      type: 'string',
      nullable: true,
    },
    eventIdentifier: {
      type: 'string',
      format: 'uuid',
    },
  },
} as IJSONSchema;

export default schema;
